import { render, staticRenderFns } from "./TrustModal.vue?vue&type=template&id=67b431fd&scoped=true&"
import script from "./TrustModal.vue?vue&type=script&lang=js&"
export * from "./TrustModal.vue?vue&type=script&lang=js&"
import style0 from "./TrustModal.vue?vue&type=style&index=0&id=67b431fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b431fd",
  null
  
)

export default component.exports